import * as React from "react";

function SvgValidityWarning(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width={20.434} height={16.804} {...props}>
        <g data-name="Group 11106" fill="#f44336">
          <path data-name="Path 43362" d="M10.217 0L0 16.8h20.434zm0 2.232l8.1 13.321h-16.2z" />
          <g data-name="Group 11144">
            <path
              data-name="Path 43363"
              d="M10.269 11.87a.637.637 0 00.635-.636V6.271a.636.636 0 00-.635-.635.636.636 0 00-.634.635v4.963a.637.637 0 00.634.636z"
            />
            <path data-name="Path 43364" d="M10.27 12.536a.7.7 0 10.7.7.7.7 0 00-.7-.7z" />
          </g>
        </g>
      </svg>
    </span>
  );
}

export default SvgValidityWarning;
